import { EUpdateModalButton, EUpdateModalSubTitle, EUpdateModalTitle } from 'lib/storage';

export enum EAddNewUpdateActionType {
  SET_IS_MODAL_OPEN_ADD_NEW = 'SET_IS_MODAL_OPEN_ADD_NEW',
  SET_IS_UPDATE_MODAL_OPEN = 'SET_IS_UPDATE_MODAL_OPEN',
  SET_UPDATE_IDS = 'SET_UPDATE_IDS',
  SET_UPDATE_CONTENT = 'SET_UPDATE_CONTENT',
  SET_CONFIRM_IS_MODAL_OPEN_ADD_NEW = 'SET_CONFIRM_IS_MODAL_OPEN_ADD_NEW',
  SAVE_EDITOR_DATA = 'SAVE_EDITOR_DATA',
  POST_UPDATE_CONFIRM_BUTTON_PRESSED = 'POST_UPDATE_CONFIRM_BUTTON_PRESSED',
  SET_UPDATE_TITLE = 'SET_UPDATE_TITLE',
  SET_DELETE_UPDATE_IS_MODAL_OPEN_ADD_NEW = 'SET_DELETE_UPDATE_IS_MODAL_OPEN_ADD_NEW',
  GET_PRODUCT_UPDATES_SUCCESS = 'GET_PRODUCT_UPDATES_SUCCESS',
  DELETE_PRODUCT_SUCCESS = 'DELETE_PRODUCT_SUCCESS',
  UPDATE_PRODUCT_SUCCESS = 'UPDATE_PRODUCT_SUCCESS',
}

export const SET_CONFIRM_IS_MODAL_OPEN = 'SET_CONFIRM_IS_MODAL_OPEN';
export const SET_IS_MODAL_OPEN = 'SET_IS_MODAL_OPEN';
export const SET_DELETE_UPDATE_IS_MODAL_OPEN = 'SET_DELETE_UPDATE_IS_MODAL_OPEN';

export interface IAddNewUpdateState {
  isModalOpen: boolean;
  isPostUpdateModalOpen: boolean;
  updateIds: string;
  editorhtml: string;
  isPostUpdateConfirmButtonPressed: boolean;
  title: string;
  isDeleteUpdateModalOpen: boolean;
  modalTitle: EUpdateModalTitle;
  updateModalButtonTittle?: EUpdateModalButton;
  updateModalSubTitle?: EUpdateModalSubTitle;
  productReleases: IProductReleasesData[];
  productReleaseObj: { title: ''; description: ''; id: '' };
  isDeleteProduct?: boolean;
  isAddProduct?: boolean;
  isProductReleasesFetched?: boolean;
}

export interface IUpdateContent {
  date: Date;
  title: string;
  description: string;
}

export interface IPostUpdateState {
  isPostUpdateModalOpen: boolean;
  isModalOpen: boolean;
  modalTitle: EUpdateModalTitle;
  isPostUpdateConfirmButtonPressed: boolean;
  updateModalButtonTittle?: EUpdateModalButton;
  updateModalSubTitle?: EUpdateModalSubTitle;
}

export interface IAddNewUpdateInput {
  id?: string;
  title: string;
  description: string;
}

export interface IDeleteUpdateState {
  isModalOpen: boolean;
  modalTitle: EUpdateModalTitle;
  isDeleteUpdateModalOpen: boolean;
  updateModalButtonTittle?: EUpdateModalButton;
  updateModalSubTitle?: EUpdateModalSubTitle;
}

export interface IProductReleasesData {
  createdAt: Date;
  createdBy: string;
  description: string;
  id: string;
  isDeleted: boolean;
  title: string;
  updatedAt: Date;
  updatedBy: string;
}
